var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfirmPaymentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 74,
    fill: "#A2DBFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M154 73.2343V80.0423C153.991 95.9998 148.824 111.527 139.269 124.308C129.714 137.089 116.284 146.439 100.982 150.963C85.679 155.488 69.3237 154.944 54.3551 149.414C39.3864 143.884 26.6064 133.663 17.9211 120.277C9.23577 106.89 5.11045 91.054 6.16041 75.1311C7.21036 59.2081 13.3793 44.0512 23.7473 31.9207C34.1152 19.7902 48.1266 11.3362 63.6918 7.81944C79.257 4.30269 95.542 5.91165 110.118 12.4064",
    stroke: "#2E82AF",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M154 21.6543L79.5618 95.6543L57.2305 73.4765",
    stroke: "#2E82AF",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmPaymentIcon);
export default __webpack_public_path__ + "static/media/ConfirmPaymentIcon.4ade1b14e4987aa8a66913fc51bb4e83.svg";
export { ForwardRef as ReactComponent };